import { defineComponent as _defineComponent } from 'vue'
import type { FormulaOperator } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormulaReadable',
  props: {
    parts: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})